const axisOptions = {
  xAxis: (options) => ({
    id: `xaxis-${new Date().getTime()}`,
    ...options
  }),
  yAxis: (options) => ({
    id: `yaxis-${new Date().getTime()}`,
    labels: {
      align: 'left',
      x: 5,
      formatter: function() {
        if (this.value >= 1000000) {
          return (this.value / 1000).toLocaleString() + 'k';
        } else if (this.value >= 1000000000) {
          return (this.value / 1000000).toLocaleString() + 'm';
        }

        return this.value.toLocaleString();
      }
    },
    lineWidth: 1,
    offset: 0,
    opposite: true,
    tickPixelInterval: 48,
    showFirstLabel: false,
    ...options,
    title: {
      ...axisOptions.yAxisTitle(options.title)
    }
  }),
  yAxisTitle: (options) => ({
    ...options,
    text: options !== undefined ? options.text : null,
    align: 'high',
    textAlign: 'left',
    x: '-100%',
    y: 12,
    offset: 0,
    useHTML: true,
    rotation: 0,
    style: {
      background: '#2E2E2E',
      color: '#FFFFFF',
      padding: '2px 6px',
      fontWeight: 'bold',
      fontSize: '11px'
    }
  })
}

export default axisOptions;